export default "__VITE_ASSET__bf1f3b94__"